var map = {
	"./compliance.png": "7HqT",
	"./e-commerce.png": "ccv6",
	"./fintech.png": "hBbS",
	"./healthcare.png": "+jOc",
	"./hr.png": "eqg1",
	"./it-sass.png": "ORUg",
	"./operations.png": "2oC2",
	"./staffing.png": "liz7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "F7Y5";